<template>
  <el-row class="i-search">
    <el-col class="i-search-row" :span="24">
      <slot></slot>
    </el-col>
  </el-row>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import "../styles/element-variables.scss";
.i-search {
  margin-top: $--main-padding;
  margin-bottom: $--main-padding;
  .i-search-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    & /deep/ .el-input {
      width: 250px;
      //margin-right: $--main-padding /2;
    }
    & /deep/ .block{
      margin-right: $--main-padding /2;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/search-wrapper.vue